import { ref, nextTick, watch, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d305b35"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名：", -1));
const _hoisted_6 = {
  class: "product-item"
};
const _hoisted_7 = {
  class: "product-item-label"
};
const _hoisted_8 = {
  class: "main-title"
};
const _hoisted_9 = {
  key: 0,
  style: {
    "color": "#ff4d4f"
  }
};
const _hoisted_10 = {
  class: "subtitle"
};
const _hoisted_11 = ["title"];
const _hoisted_12 = {
  class: "appListPopover-content"
};
const _hoisted_13 = {
  class: "appListPopover-content-title"
};
const _hoisted_14 = {
  class: "inf-label"
};
const _hoisted_15 = {
  class: "inf-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title",
  style: {
    "margin-left": "16px"
  }
}, "商品信息：", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title",
  style: {
    "margin-left": "16px"
  }
}, "商品状态：", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-time-title",
  style: {
    "margin-left": "16px"
  }
}, "时间：", -1));
const _hoisted_20 = {
  class: "filter-list"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "渠道：", -1));
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1,
  style: {
    "height": "32px",
    "line-height": "32px"
  }
};
const _hoisted_24 = {
  class: "filter-list"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "处理状态：", -1));
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = {
  key: 2
};
const _hoisted_29 = {
  key: 3
};
const _hoisted_30 = {
  class: "btn-content"
};
import { getProdTypeByDbtId, getProductStatistics } from '@/api/goodsJudge';
import { useAppDimensionStore } from '@/store/appDimension';
import { OK, searchFields, getAppListInformation, copy } from '@/common';
import { DynamicSingleVirtualScrollSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { message } from 'ant-design-vue';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';
// 审核状态常量
export default /*#__PURE__*/_defineComponent({
  __name: 'JudgeFilterBlock',
  emits: ['filterSubmit', 'setProductName', 'update:tableLoading'],
  setup(__props, {
    expose,
    emit
  }) {
    const route = useRoute();
    const appDimensionStore = useAppDimensionStore();
    // const props = defineProps({
    //   tableLoading: Boolean
    // })
    const statusList = [{
      label: '全部',
      value: 'all'
    }, {
      label: '待处理',
      value: 'unhandled'
    }, {
      label: '已处理',
      value: 'handled'
    }, {
      label: '已驳回',
      value: 'rejected'
    }, {
      label: '已删除',
      value: 'deleted'
    }];
    const goodsStatusList = [{
      label: '全部',
      value: ''
    }, {
      label: '有效',
      value: 10
    }, {
      label: '失效',
      value: 20
    }];
    const STATUS_DELETED = 100; // 已删除状态
    const publishStatuses = ref('all'); // 处理状态
    const dbtId = ref(null); // 产品名
    const channel = ref(null); // 渠道
    const productList = ref([]); // 产品列表
    const channelList = ref([]); // 渠道列表
    const productSelectRef = ref(null);
    const dynamicSelectRef = ref(null);
    const productName = ref(''); // 商品信息
    const idsValue = ref([]); // 商品信息
    const timeRangeType = ref('judge');
    const timeRangeValue = ref();
    const goodsStatus = ref(''); // 商品状态
    // 添加预设时间范围
    const rangePresets = ref([{
      label: '今日',
      value: [dayjs().startOf('day'), dayjs().endOf('day')]
    }, {
      label: '昨日',
      value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')]
    }, {
      label: '最近7天',
      value: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')]
    }, {
      label: '最近30天',
      value: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')]
    }]);
    // 添加新的响应式变量
    const unhandledStatistics = ref(null);
    const handledStatistics = ref(null);
    // 已驳回
    const rejectedStatistics = ref(null);
    const deletedStatistics = ref(null);
    // 处理状态
    const publishStatusMap = new Map([['all', [10, 20, 0]], ['unhandled', [0, 20]], ['handled', [10]], ['rejected', [0, 20]]]);
    const publishApprovalStatusesList = new Map([['all', [10, 20, 30]], ['unhandled', [10, 30]], ['handled', [10, 20, 30]], ['rejected', [20]], ['deleted', [STATUS_DELETED]]]);
    const filterSubmit = async () => {
      var _productList$value$fi;
      const params = {
        publishStatuses: publishStatusMap.get(publishStatuses.value),
        dbtId: dbtId.value,
        prodChnl: channel.value,
        fuzzy: productName.value,
        ids: idsValue.value,
        // 处理状态
        approvalStatuses: publishApprovalStatusesList.get(publishStatuses.value),
        // 时间类型
        timeRangeType: timeRangeType.value,
        // 时间范围
        timeRangeValue: timeRangeValue.value,
        // 商品状态
        prodStatus: goodsStatus.value
      };
      emit('filterSubmit', params);
      emit('setProductName', (_productList$value$fi = productList.value.find(item => item.value === dbtId.value)) === null || _productList$value$fi === void 0 ? void 0 : _productList$value$fi.label);
      // 获取统计数据
      await getStatistics();
    };
    const init = async () => {
      publishStatuses.value = 'unhandled';
      channel.value = null;
      await getProducts(); // filterSubmit会在getProducts -> getChannelList中自动调用
    };
    const getChannelList = async () => {
      if (!dbtId.value) return;
      channelList.value = [];
      channel.value = null;
      try {
        const {
          data,
          code
        } = await getProdTypeByDbtId({
          dbtId: dbtId.value
        });
        if (code === OK) {
          var _data$prodChnl;
          channelList.value = (_data$prodChnl = data.prodChnl) === null || _data$prodChnl === void 0 ? void 0 : _data$prodChnl.map(item => {
            return {
              label: item.channelName,
              value: item.channelCode
            };
          });
          if (channelList.value.length) {
            channel.value = channelList.value[0].value;
            // 只在手动调用时执行筛选，避免初始化时重复调用
            if (!route.query.dbtId) {
              filterSubmit();
            }
          } else {
            channel.value = null;
            message.warning('暂无渠道');
          }
        }
      } catch (e) {}
    }; // 获取渠道列表
    const changeChannel = value => {
      channel.value = value;
      filterSubmit();
    }; // 切换渠道
    const changePublishStatus = value => {
      publishStatuses.value = value;
      filterSubmit();
    }; // 切换处理状态
    const getProducts = async (autoChange = true) => {
      var _productSelectRef$val;
      productList.value = appDimensionStore.goodsJudgeProducts;
      await nextTick();
      (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(productList.value);
      if (dynamicSelectRef.value) {
        dynamicSelectRef.value.displayOptions = productList.value;
      }
      if (productList.value.length && autoChange) {
        dbtId.value = productList.value[0].value;
        await getChannelList();
      }
    }; // 获取产品列表
    // 维度缓存刷新后（提交/通过/驳回/同步）把最新产品数据同步给下拉，仅更新选项不改当前选中
    const syncProductOptions = () => {
      var _productSelectRef$val2;
      productList.value = appDimensionStore.goodsJudgeProducts;
      (_productSelectRef$val2 = productSelectRef.value) === null || _productSelectRef$val2 === void 0 || _productSelectRef$val2.initializeOptions(productList.value);
      if (dynamicSelectRef.value) {
        dynamicSelectRef.value.displayOptions = productList.value;
      }
    };
    watch(() => appDimensionStore.goodsJudgeProducts, () => {
      if (goodsJudgeInitialized.value) syncProductOptions();
    });
    // 获取统计数据
    const getStatistics = async () => {
      if (!dbtId.value || !channel.value) return;
      const baseParams = {
        pageNum: 1,
        pageSize: 100000,
        approvalStatuses: [10, 20, 30],
        fuzzy: productName.value,
        orderBy: 'submit_time',
        orderDirection: 'desc',
        dbtId: String(dbtId.value),
        prodChnl: String(channel.value),
        // 从带 ids 的链接进入时，列表查询会按 ids 过滤，统计需保持同样的过滤条件，
        // 否则会出现「表格查不到数据、tab 统计却有值」的不一致
        ...(idsValue.value.length ? {
          ids: idsValue.value
        } : {})
      };
      try {
        // 获取待处理数据
        const unhandledRes = await getProductStatistics({
          ...baseParams,
          approvalStatuses: [10, 30],
          publishStatuses: [0, 20]
        });
        if (unhandledRes.code === OK) {
          var _unhandledRes$data;
          unhandledStatistics.value = (_unhandledRes$data = unhandledRes.data) === null || _unhandledRes$data === void 0 ? void 0 : _unhandledRes$data.total;
        }
        // 获取已处理数据
        const handledRes = await getProductStatistics({
          ...baseParams,
          publishStatuses: [10]
        });
        if (handledRes.code === OK) {
          var _handledRes$data;
          handledStatistics.value = (_handledRes$data = handledRes.data) === null || _handledRes$data === void 0 ? void 0 : _handledRes$data.total;
        }
        // 获取已驳回数据
        const rejectedRes = await getProductStatistics({
          ...baseParams,
          approvalStatuses: [20],
          publishStatuses: [0, 20]
        });
        if (rejectedRes.code === OK) {
          var _rejectedRes$data;
          rejectedStatistics.value = (_rejectedRes$data = rejectedRes.data) === null || _rejectedRes$data === void 0 ? void 0 : _rejectedRes$data.total;
        }
        // 获取删除数据
        const deleteRes = await getProductStatistics({
          ...baseParams,
          isDeleted: 1
        });
        if (deleteRes.code === OK) {
          var _deleteRes$data;
          deletedStatistics.value = (_deleteRes$data = deleteRes.data) === null || _deleteRes$data === void 0 ? void 0 : _deleteRes$data.total;
        }
      } catch (err) {}
    };
    const handleRouteParams = async () => {
      const {
        dbtId: routeDbtId,
        prodChnl: routeProdChnl,
        ids
      } = route.query;
      // 从消息卡片等外部链接进入时，与菜单进入（init）保持一致，默认落到「待处理」
      publishStatuses.value = 'unhandled';
      if (ids) {
        idsValue.value = ids.split(',');
      }
      if (routeDbtId && typeof routeDbtId === 'string') {
        dbtId.value = routeDbtId;
        await getProducts(false);
        await getChannelList();
        if (routeProdChnl && typeof routeProdChnl === 'string' && channelList.value.some(item => item.value === routeProdChnl)) {
          channel.value = routeProdChnl;
        }
        // 在所有数据准备完成后执行一次筛选
        await filterSubmit();
      }
    };
    const goodsJudgeMounted = ref(false);
    const goodsJudgeInitialized = ref(false);
    const initializeGoodsJudgePage = async () => {
      if (!goodsJudgeMounted.value || !appDimensionStore.goodsJudgeLoaded || goodsJudgeInitialized.value) return;
      goodsJudgeInitialized.value = true;
      if (Object.keys(route.query).length) {
        await handleRouteParams();
      } else {
        await init();
      }
    };
    watch(() => appDimensionStore.goodsJudgeLoaded, () => {
      initializeGoodsJudgePage();
    });
    onMounted(async () => {
      goodsJudgeMounted.value = true;
      await initializeGoodsJudgePage();
    });
    expose({
      channel,
      dbtId,
      filterSubmit,
      init,
      getStatistics
    });
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_unref(DynamicSingleVirtualScrollSelect), {
        ref_key: "dynamicSelectRef",
        ref: dynamicSelectRef,
        modelValue: dbtId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dbtId.value = $event),
        allowClear: true,
        popupClassName: "vertical-product-select",
        placeholder: "请选择",
        labelField: "label",
        valueField: "value",
        width: "260px",
        searchFields: _unref(searchFields),
        "dropdown-max-height": 450,
        "item-height": 70,
        showDetail: true,
        onChange: getChannelList
      }, {
        "product-item": _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1), item.extData.unHandleProducts > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(待审核)")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
          class: "file-path",
          title: item.extData.filePath
        }, _toDisplayString(item.extData.filePath ? item.extData.filePath : '-'), 9, _hoisted_11)])])]),
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_15, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_16]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "searchFields"]), _hoisted_17, _createVNode(_component_a_input, {
        value: productName.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => productName.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入内购ID/商品名称",
        style: {
          "width": "180px"
        }
      }, null, 8, ["value"]), _hoisted_18, _createVNode(_component_a_select, {
        value: goodsStatus.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => goodsStatus.value = $event),
        options: goodsStatusList,
        style: {
          "width": "120px"
        }
      }, null, 8, ["value"]), _hoisted_19, _createVNode(_component_a_select, {
        ref: "select",
        value: timeRangeType.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => timeRangeType.value = $event),
        style: {
          "width": "132px"
        },
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "judge"
        }, {
          default: _withCtx(() => [_createTextVNode("最近提审时间")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "sync"
        }, {
          default: _withCtx(() => [_createTextVNode("最近同步时间")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"]), _createVNode(_component_a_range_picker, {
        value: timeRangeValue.value,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => timeRangeValue.value = $event),
        "show-time": "",
        presets: rangePresets.value,
        style: {
          "width": "340px"
        }
      }, null, 8, ["value", "presets"])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, channelList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, item => {
        return _openBlock(), _createBlock(_component_a_button, {
          type: channel.value === item.value ? 'primary' : 'default',
          key: item.value,
          onClick: $event => changeChannel(item.value),
          style: {
            "margin-right": "12px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["type", "onClick"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_23, "暂无渠道"))]), _createElementVNode("div", _hoisted_24, [_hoisted_25, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, item => {
        return _createVNode(_component_a_button, {
          key: item.value,
          type: publishStatuses.value === item.value ? 'primary' : 'default',
          onClick: $event => changePublishStatus(item.value),
          style: {
            "margin-right": "12px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1), item.value === 'unhandled' ? (_openBlock(), _createElementBlock("span", _hoisted_26, "(" + _toDisplayString(unhandledStatistics.value || 0) + ")", 1)) : _createCommentVNode("", true), item.value === 'handled' ? (_openBlock(), _createElementBlock("span", _hoisted_27, "(" + _toDisplayString(handledStatistics.value || 0) + ")", 1)) : _createCommentVNode("", true), item.value === 'rejected' ? (_openBlock(), _createElementBlock("span", _hoisted_28, "(" + _toDisplayString(rejectedStatistics.value || 0) + ")", 1)) : _createCommentVNode("", true), item.value === 'deleted' ? (_openBlock(), _createElementBlock("span", _hoisted_29, "(" + _toDisplayString(deletedStatistics.value || 0) + ")", 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["type", "onClick"]);
      }), 64)), _createElementVNode("div", _hoisted_30, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])])])]);
    };
  }
});